module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBoldItalic.76dcfc0e.woff2";